/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState } from "react";
import CustomButton from "../../components/customButton";
import {
  Dialog,
  DialogContent,
  DialogHeader,
} from "../../components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";

import useCartDetail from "../../store/cart/getcartDetails";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useStoreDeliveryUser from "../../store/addresse/deliveryUser";
import useStoreQuantite from "./store";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Add_address_modal from "./Add_address_modal";
import { FaArrowLeft } from "react-icons/fa";
import Breadcrumb from "../../components/Breadcrumb";
import { formatNombre, scrollToTop } from "../../lib/utils";
import { URL } from "../../lib/apis";

const Adresse = () => {
  const [adress, setAdress] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation()
  const order = location.state;
  // console.log(order)
  const [openMoal, setOpenModal] = useState(false);
  const userId = localStorage.getItem("user");
  const [openMoal2, setOpenModal2] = useState(false);
  const token = localStorage.getItem("token");
  const [idAdsress, setIdAddress] = useState<number>(0)
  const [loader, setLoader] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { cartDetails, fetchAllCat } = useCartDetail((state) => state);

  const [selectedRow, setSelectedRow] = useState<any | null>(null);

  useEffect(() => {
    scrollToTop()
  }, [])

  const { DeliveryUser, fetchDeliveryUser } =
    useStoreDeliveryUser();

  // const { loadingOrder } = useOrderStore();

  const handleRowClick = (row: any) => {
    setSelectedRow(row);
    setAdress(true);
  };

  useEffect(() => {
    if (userId) {
      fetchDeliveryUser(userId);
    }
    // eslint-disable-next-line
  }, [userId, openMoal]);

  const handleOrderConfirmation = () => {
    setOpenModal2(true);
  };


  // const { addDeliveryAddress } = useAddessDeliveryStore(
  //   (state) => state
  // );

  useEffect(() => { }, []);

  const navigate = useNavigate();






  // eslint-disable-next-line
  const { quantitee } = useStoreQuantite();

  const request2 = async () => {
    setLoader(true)

    try {
      // Check if cartDetails.data is defined and is an array

      const orderPayload = {
        user_id: parseInt(userId ?? ""), // Récupération de l'ID de l'utilisateur
        delivery_id: DeliveryUser[idAdsress]?.delivery_id, // ID de la première adresse de livraison sélectionnée
        order_details: order.map((item: any) => ({
          product_id: item.product.product_id, // ID du produit
          quantity: item.quantity ?? 0, // Quantité du produit
        })),
      };
      // console.log("Order Payload:", orderPayload);
      // console.log("Order DeliveryUser:", DeliveryUser[idAdsress?idAdsress:0]);
      // setLoader(false)
      // return

      // Ensure order_details is not empty
      if (orderPayload.order_details?.length === 0) {
        throw new Error("Aucun détail de commande disponible.");
      }

      // Call the AddOrder function from your store
      // await AddOrder(orderPayload);
      const response = await fetch(
        `${URL}/orders`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(orderPayload),
        }
      );
      const data: any = await response.json();
      const myOrder = await axios.get(`${URL}/users/${userId}/orders/${data.data.order_id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      // On successful order, navigate to the payment page or show a success message
      toast.success(t("commande_reussie"));
      fetchAllCat()
      // return
      setTimeout(() => {
        navigate(`/paiement_achat/${data.data.order_id}`, { state: myOrder.data.orders[0] }); // Adjust the route as needed
        setOpenModal2(false);
      }, 2000)



    } catch (error: any) {
      toast.error(
        error.message || "Une erreur s'est produite lors de la commande."
      );
    } finally {
      setLoader(false)
    }
  };



  // const isReady3 = () => {
  //   return !selectedRow || loadingOrder;
  // };


  useEffect(() => {
    fetchAllCat();
    // eslint-disable-next-line
  }, []);



  // eslint-disable-next-line

  const calculPrix = (item: any) => {
    let prix = 0
    item.forEach((produit: any) => {
      prix += Number(produit.product.price * produit.quantity)
    })
    return formatNombre(prix)
  }

  return (
    <div className="h-full pt-2 bg-softGrey">
      <div className="flex flex-row  items-center py-5 justify-start w-full ml-10">
        <FaArrowLeft
          onClick={() => navigate(-1)}
          className=" text-green-500 text-3xl"
          style={{ cursor: "pointer" }}
        />
        <Breadcrumb />
      </div>
      <div className="w-full flex justify-center items-center py-5 bg-white">
        <h1 className="text-[20px]">{t("passer_commande")} ({order.length} {t("produit")})</h1>
      </div>
      <div className=" flex flex-col md:grid md:grid-cols-5 p-8 bg-gray-100 gap-3">
        <div className="col-span-3">
          <div className="bg-white p-6 shadow-lg rounded-lg h-auto">
            <div className="flex flex-col items-start justify-start gap-3">
              <div className="flex flex-col gap-2">
                <span className="text-[16px] mt-2">{t("address_livraison")}</span>
                <span className="text-grey text-[11px] my-3">
                  {t("text_address")}
                </span>
              </div>



              {adress || selectedRow ? (
                <div className="w-full flex flex-col gap-2">
                  <div className="bg-third py-2 px-4 flex flex-col gap-2 w-full">
                    <span className="text-xs">
                      {t("nom")}:  {selectedRow?.delivery_name}
                    </span>
                    <span className="text-xs">
                      {t("address")}: {selectedRow?.delivery_address}
                    </span>
                    <span className="text-xs">
                      {t("pays")}: {selectedRow?.delivery_country}
                    </span>
                    <span className="text-xs">
                      {t("region")}: {selectedRow?.delivery_region}
                    </span>
                    <span className="text-xs">
                      {t("phone")}:
                      {selectedRow?.delivery_phone_number}
                    </span>
                  </div>

                  <div className="w-full flex justify-between">
                    <span onClick={() => {
                      setSelectedRow(null)
                      setAdress(false)
                    }} className="text-[11px] border-b-[1px] border-solid border-third py-1 cursor-pointer">
                      {t("modifier")}
                    </span>
                    <span
                      className="text-secondary hover:underline text-[11px] cursor-pointer"
                      onClick={() => {
                        setOpenModal(true);
                      }}
                    >
                      {t("changer")}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="flex justify-between w-full px-4">
                  <div>
                    <CustomButton
                      className="flex gap-2 py-2 px-4 bg-white"
                      onClick={() => setOpenModal(true)}
                    >
                      <img
                        className="h-[21px] w-[21px]"
                        src="/red.svg"
                        alt=""
                      />
                      <span>{t("ajouter_addresse")}</span>
                    </CustomButton>
                  </div>

                  <div>
                    {" "}
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <div className="bg-softGrey px-3 h-full flex gap-2 text-xs font-normal rounded-l-[29px] min-w-[120px] items-center">
                          <span className="text-grey">
                            {t("selectionner_addresse")} !!!
                          </span>
                          <img src="/chevron-up.svg" alt="Chevron Up" />
                        </div>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent className="">
                        <DropdownMenuGroup>
                          <div className="overflow-x-auto">
                            {!selectedRow && (
                              <div className="min-w-full bg-white shadow-md rounded-lg">
                                <table className="min-w-full table-auto text-left text-sm">
                                  <thead className="bg-gray-200">
                                    <tr>
                                      <th className="py-3 px-4">{t("nom")}</th>
                                      <th className="py-3 px-4">{t("pays")}</th>
                                      <th className="py-3 px-4">{t("region")}</th>
                                      <th className="py-3 px-4">{t("ville")}</th>
                                      <th className="py-3 px-4">{t("phone")}</th>
                                      <th className="py-3 px-4">{t("addresse")}</th>
                                      <th className="py-3 px-4">
                                        {t("date_creation")}
                                      </th>
                                      <th className="py-3 px-4">
                                        {t("date_update")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {DeliveryUser.map((delivery: any, index: number) => (
                                      <tr
                                        key={index}
                                        className="border-b"
                                        onClick={() => {
                                          setIdAddress(index)
                                          handleRowClick(delivery);
                                        }}
                                      >
                                        <td className="py-3 px-4">
                                          {delivery.delivery_name}
                                        </td>
                                        <td className="py-3 px-4">
                                          {delivery.delivery_country}
                                        </td>
                                        <td className="py-3 px-4">
                                          {delivery.delivery_region}
                                        </td>
                                        <td className="py-3 px-4">
                                          {delivery.delivery_city}
                                        </td>
                                        <td className="py-3 px-4">
                                          {delivery.delivery_phone_number}
                                        </td>
                                        <td className="py-3 px-4">
                                          {delivery.delivery_address}
                                        </td>
                                        <td className="py-3 px-4">
                                          {new Date(
                                            delivery.created_at
                                          ).toLocaleDateString()}
                                        </td>
                                        <td className="py-3 px-4">
                                          {new Date(
                                            delivery.updated_at
                                          ).toLocaleDateString()}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </DropdownMenuGroup>
                        <DropdownMenuSeparator />
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-span-2">
          <div className="bg-white p-6 shadow-lg rounded-lg h-auto">
            <div className="flex flex-col h-full justify-between">
              <div className="my-2 text-2xl">{t("mes_produits")}</div>
              {order.map((item: any, index: any) => {
                return (
                  <div className="text-center">
                    <div className="border-t border-gray-300"></div>
                    <div className="flex justify-between my-2 text-gray-500">
                      <div>
                        {item.quantity}{" "}
                        {i18n.language === "fr" ? item.product.type : item.product.type_en}
                        {i18n.language === "fr" ? item.product.product_name : item.product.product_name_en}
                      </div>
                      <div>{formatNombre(parseInt(item.product.price) * item.quantity)}F</div>
                    </div>
                    <div className="border-t border-gray-300"></div>
                  </div>
                );
              })}
              <div className="flex justify-between">
                <div className="font-bold">Total</div>
                <div className="font-bold">{calculPrix(order)}F</div>
              </div>

              <div className="flex justify-center w-full mt-2">
                <CustomButton
                  rounded
                  className="bg-primary text-white px-8 py-3 text-[11px] max-w-[300px] w-full"
                  onClick={() => {
                    if (!adress) {
                      toast.error(t("choisir_adresse"))
                      return
                    }
                    handleOrderConfirmation();
                  }}
                // disabled={isReady2()}
                >
                  <span>{t("passer_commande")}</span>
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        openMoal &&
        <Add_address_modal openMoal={openMoal} setOpenModal={setOpenModal} />
      }

      <Dialog open={openMoal2} onOpenChange={setOpenModal2}>
        <DialogContent>
          <DialogHeader>
            <div className="bg-primary px-2 py-2 flex justify-between sm:rounded-lg">
              <span className="text-[17px] text-white">
                {t("confirmer_commande")}
              </span>
              <img
                onClick={() => setOpenModal2(false)}
                className="cursor-pointer"
                src="/closeIcon.svg"
                alt="Close"
              />
            </div>
          </DialogHeader>

          <div className="px-5 pt-2 pb-5 flex flex-col gap-3">
            <h2 className="text-lg font-semibold">{t("resumer_commande")}</h2>
            <div>
              <h3 className="font-medium">{t("address_livraison")}</h3>
              <p>  {t("nom")}: {selectedRow?.delivery_name}</p>
              <p> {t("address")}: {selectedRow?.delivery_address}</p>
              <p> {t("ville")}: {selectedRow?.delivery_city}</p>
              <p> {t("region")}: {selectedRow?.delivery_region}</p>

              <p>{t("phone")}:  {selectedRow?.delivery_phone_number}</p>
            </div>
            <div>
              <h3 className="font-medium">Articles</h3>
              {order.map((item: any, index: any) => (
                <div key={index} className="flex justify-between">
                  <span>
                    {item.quantity}{" "}
                    {item.product.type}
                    {item.product.product_name}
                  </span>
                  <span>{parseFloat(item.product.price) * item.quantity}F</span>
                </div>
              ))}
              <div className="flex justify-between font-bold mt-2">
                <span>Total</span>
                <span>{calculPrix(order)}F</span>
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <CustomButton
                className="bg-green-500 text-white px-4 py-2 mr-2"
                onClick={request2}
                disabled={loader}
              >
                {loader ? "Patienter..." : t("confirmer_commande")}
              </CustomButton>
              <CustomButton
                className="bg-gray-300 text-black px-4 py-2"
                onClick={() => setOpenModal2(false)}
              >
                {t("annuler")}
              </CustomButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <ToastContainer />
    </div>
  );
};
export default Adresse;
